import { usePlatformsSectionContent } from './usePlatformsSectionContent';
import { parsePlatformsEntryPointsContent } from '../utils/platformsContent';

export const usePlatformsEntryPointsContent = () =>
  usePlatformsSectionContent(parsePlatformsEntryPointsContent);
